import React from 'react';
import { CheckCircle } from 'lucide-react'; // Import the CheckCircle icon
// Motion only. Every colour, size and position on this page still comes from
// the inline styles below; success.css adds nothing but the arrival.
import './success.css';

const PaymentStatus = () => {
  return (
    <div className="pay-status" style={{ textAlign: "center", marginTop: "50px" }}>
      <h1 className="pay-status-heading" style={{ color: "green" }}>
        <CheckCircle
          className="pay-status-icon"
          style={{
            display: 'inline-block',
            marginRight: '10px',
            verticalAlign: 'middle',
            width: '48px',  // Increased size
            height: '48px', // Increased size
          }}
        />
        Order Placed Successfully!
      </h1>
      <p className="pay-status-note">Thank you for your purchase.</p>
    </div>
  );
};

export default PaymentStatus;